// extracted by mini-css-extract-plugin
export default {"path":"energy-flow-path_path__lkeIU"};